;(function () {
  'use strict'

  angular
    .module('contrast.settings.groups')
    .controller('AddGroupCtrl', AddGroupCtrl)

  function AddGroupCtrl(
    $scope,
    $controller,
    $q,
    $location,
    logger,
    ErrorService,
    groupService,
    UserService,
    groupsApiConfig
  ) {
    'ngInject'

    var baseCtrl

    this.$onInit = function () {
      baseCtrl = $controller('BaseGroupCtrl', {
        $scope: $scope
      })
      baseCtrl.$onInit()

      angular.extend(this, baseCtrl)

      angular.extend($scope, {
        saveGroup: saveGroup,
        checkName: checkName
      })

      init()
    }

    function init() {
      $scope.loadPromise = $q.all([baseCtrl.init()]).then(function () {
        baseCtrl.removeCurrentUser()
        baseCtrl.addException()
      })
    }

    function saveGroup() {
      $scope.saving = true
      return groupsApiConfig
        .createGroup(groupService.createGroupCreationRequest($scope.group))
        .then(
          function (response) {
            $scope.saving = false
            logger.logSuccess(response.data.messages[0])
            $location.path(UserService.buildUrl('/settings/groups'))
          },
          function (response) {
            $scope.saving = false
            ErrorService.processError(response)
          }
        )
    }

    function checkName() {
      $scope.validation.pristine = true
      if (
        angular.isDefined($scope.group.name) &&
        $scope.group.name.length > 0
      ) {
        $scope.validation.setName = true
        $scope.checking = true
        groupsApiConfig.checkName($scope.group.name).then(
          function () {
            $scope.checking = false
            $scope.validation.unique = true
          },
          function () {
            $scope.checking = false
            $scope.validation.unique = false
          }
        )
      } else {
        $scope.validation.unique = true
        $scope.validation.setName = false
      }
    }

    this.$onInit()
  }
})()
